import { useBaseAction, useHandleModals, useUserRole } from "hooks/core";
import { API } from "constants/RestApi";
import { IBaseEntity } from "core/types/entities";
import { UserPermissions } from "../../../core/types/enums/PermissionsEnum";

const actions = ["cancel"] as const;

const useCancelWO = <T extends IBaseEntity>() => {
  const { request } = useBaseAction();
  const { permissionGranted } = useUserRole();
  const canManage = permissionGranted([UserPermissions["WorkOrder.Upsert"]]);
  const { modals, toggleModal, setSelectedEntity, selectedEntity } = useHandleModals<
    T,
    typeof actions[number]
  >({
    modalsKeys: actions,
  });

  const requestCancelWO = async (workOrder: T, provideUrl?: string) => {
    await request({
      method: "PUT",
      url: provideUrl ?? API.WORK_ORDERS_CANCEL,
      body: { id: workOrder.id, rowVersion: workOrder.rowVersion },
      successMessage: "Item has been canceled",
      useLoader: true,
    });
  };

  const onSaveCancelHandeler = async (provideUrl?: string) => {
    if (selectedEntity) {
      await requestCancelWO(selectedEntity, provideUrl);
    }
    toggleModal({ key: "cancel", hideAll: true });
  };

  const onClickCancelBtn = (workOrder: T) => {
    setSelectedEntity(workOrder);
    toggleModal({ key: "cancel", value: true });
  };

  return {
    requestCancelWO,
    modals,
    toggleModal,
    onSaveCancelHandeler,
    setSelectedEntity,
    onClickCancelBtn,
    canManage,
  };
};

export default useCancelWO;
